import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import AlertTypeCategorySelector from './AlertTypeCategorySelector';

const IncidentTypeModal = ({ show, onHide, onSave }) => {
  const [type, setType]    = useState('');
  const [cat, setCat]      = useState('');

  const handleSave = () => {
    onSave?.({ incidentType: type, category: cat });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="py-2 px-3" closeButton>
        <Button
          variant="outline-danger"
          className="w-100 d-flex align-items-center justify-content-center gap-2"
          disabled
        >
          <ExclamationTriangleFill size={18} />
          Incident Type
        </Button>
      </Modal.Header>

      <Modal.Body className="pt-2 pb-3">
        <AlertTypeCategorySelector
          selectedType={type}
          selectedCategory={cat}
          onTypeChange={setType}
          onCategoryChange={setCat}
        />
      </Modal.Body>

      <Modal.Footer className="py-2">
        <Button
          variant="primary"
          className="w-100 py-1"
          disabled={!type || !cat}
          onClick={handleSave}
        >
          Use Selection
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IncidentTypeModal;
